package one.healthium.onboarding.ui.utils

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.NativePaint
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Paint
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawOutline
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.drawIntoCanvas
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

fun DrawScope.drawShadow(
    path: Path,
    color: Color = Color.Black.copy(0.25f),
    blur: Dp = 4.dp,
    offsetY: Dp = 0.dp,
    offsetX: Dp = 0.dp,
) {
    drawIntoCanvas { canvas ->
        val paint = Paint().apply {
            this.color = color
            if (blur.toPx() > 0f) {
                asFrameworkPaint().setMaskFilter(blur.toPx())
            }
        }
        canvas.save()
        canvas.translate(offsetX.toPx(), offsetY.toPx())
        canvas.drawOutline(Outline.Generic(path), paint)
        canvas.restore()
    }
}

internal expect fun NativePaint.setMaskFilter(blurRadius: Float)